import { ConcreteEncodable } from "./ConcreteEncodable";

import { StandardTimeImplEncoder } from "../../encoder/StandardTimeImplEncoder";

import * as CubiqTS from "../../index";
import { StandardTime } from "../StandardTime";

export class StandardTimeImpl extends ConcreteEncodable implements StandardTime {
  public static enType: string = "com.bcdfx.model.StandardTimeImpl";

  /*FID=1*/
  public hours: number;
  /*FID=2*/
  public minutes: number;
  /*FID=3*/
  public seconds: number;
  /*FID=4*/
  public timeZone: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StandardTimeImplEncoder.Instance;
    this.setEncodableType(StandardTimeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StandardTimeImpl[" +
      "hours=" +
      this.hours +
      "minutes=" +
      this.minutes +
      "seconds=" +
      this.seconds +
      "timeZone=" +
      this.timeZone +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
